
import React from 'react';
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight, HelpCircle } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface NavigationControlsProps {
  currentStep: number;
  totalSteps: number;
  onBack: () => void;
  onNext: () => void;
}

export const NavigationControls: React.FC<NavigationControlsProps> = ({ 
  currentStep, 
  totalSteps, 
  onBack, 
  onNext 
}) => {
  return (
    <div className="flex justify-between items-center mb-4">
      <Button 
        variant="outline"
        onClick={onBack}
        disabled={currentStep === 0}
        className="w-24"
        size="sm"
      >
        <ChevronLeft className="mr-1 h-4 w-4" />
        Back
      </Button>
      
      <div className="flex items-center space-x-2">
        <span className="text-sm text-white/70">
          Step {currentStep + 1} of {totalSteps}
        </span>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button variant="ghost" size="icon" className="h-6 w-6 text-white/70">
                <HelpCircle className="h-4 w-4" />
              </Button>
            </TooltipTrigger>
            <TooltipContent side="top">
              <p className="w-[200px] text-xs">
                Read through each tutorial step carefully. Some steps include interactive elements to help you understand key concepts.
              </p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
      
      <Button 
        onClick={onNext} 
        className="w-36 bg-web3-green hover:bg-web3-green/80"
        size="sm"
      >
        {currentStep === totalSteps - 1 ? 'Start Simulation' : 'Next'}
        {currentStep !== totalSteps - 1 && <ChevronRight className="ml-1 h-4 w-4" />}
      </Button>
    </div>
  );
};
